import React from 'react';

import { Box, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

type DrawerBackHeaderProps = {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  withoutDivider?: boolean;
  onBack?: () => void;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: ({ withoutDivider }: { withoutDivider?: boolean }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: spacing(2),
    borderBottom: withoutDivider ? 'none' : `1px solid ${palette.divider}`,
  }),
  title: {
    flexGrow: 1,
    margin: '4px 0',
  },
  backButton: {
    marginRight: spacing(1),
    color: palette.text.primary,
  },
}));

export default function DrawerBackHeader({
  title,
  withoutDivider = false,
  onBack,
  description,
}: DrawerBackHeaderProps) {
  const classes = useStyles({ withoutDivider });

  return (
    <Box className={classes.root}>
      {onBack && (
        <IconButton
          aria-label="back"
          className={classes.backButton}
          onClick={onBack}
          size="small"
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      )}

      <Box className={classes.title}>
        {typeof title === 'string' ? (
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {title}
          </Typography>
        ) : (
          title
        )}

        {description &&
          (typeof description === 'string' ? (
            <Typography variant="caption" color="textSecondary">
              {description}
            </Typography>
          ) : (
            description
          ))}
      </Box>
    </Box>
  );
}
